import React from "react"
import PropTypes from "prop-types"
import CarIconLoader from "./CarIconLoader"

const Loader = ({ endDate, isInstructorSearch }) => {
  const message = isInstructorSearch ? (
    <>
      We&apos;re searching your instructor&apos;s schedule for availabiltility.
    </>
  ) : (
    <>We&apos;re searching instructor schedules near you.</>
  )

  return (
    <div style={{ padding: 20, textAlign: "center" }}>
      <h3>
        {message}
        <br />
        <br />
        This can take up to 40 seconds to complete - thank you for your
        patience!
      </h3>
      <div style={{ marginBottom: 40 }}>
        Searching schedules between <span className="date-underline">now</span>{" "}
        and <span className="date-underline">{endDate}</span>...
      </div>
      <CarIconLoader />
    </div>
  )
}
Loader.propTypes = {
  endDate: PropTypes.string.isRequired,
  isInstructorSearch: PropTypes.bool,
}
Loader.defaultProps = {
  isInstructorSearch: false,
}

export default Loader
